import type { RovoAppsCollectionConfig } from './types';

import RovoCollection1 from '../assets/rovoCollectionAssets/rovo_collection_1.png';
import RovoCollection2 from '../assets/rovoCollectionAssets/rovo_collection_2.png';
import RovoCollection3 from '../assets/rovoCollectionAssets/rovo_collection_3.png';
import RovoCollection4 from '../assets/rovoCollectionAssets/rovo_collection_4.png';

export const rovoCollectionConfig: RovoAppsCollectionConfig = {
  id: 'atlassian-rovo',
  title: 'Work smarter, faster with Rovo-powered apps',
  categories: [
    {
      id: 'Administrative tools',
      label: 'Admin tools',
      title: 'Amplify admin efficiency with Rovo',
      tabAriaLabel: 'Switch to Rovo-powered apps for admin tools',
      description: 'Enable admins to automate, oversee, and streamline with Rovo intelligence.',
      linkText: 'Explore all apps',
      linkHref: '/collections/atlassian-rovo?categories=Administrative+tools',
      linkAriaLabel: 'Open the full list of available Rovo-powered apps for admin tools',
      image: RovoCollection1,
    },
    {
      id: 'Content and communication',
      label: 'Content',
      title: 'Publish content faster than ever',
      tabAriaLabel: 'Switch to Rovo-powered apps for content',
      description:
        'Quickly summarize pages and transcripts, draft articles, and generate captions so your team delivers consistent, accessible documentation in record time.',
      linkText: 'Explore all apps',
      linkHref: '/collections/atlassian-rovo?categories=Content+and+communication',
      linkAriaLabel: 'Open the full list of available Rovo-powered apps for content',
      image: RovoCollection2,
    },
    {
      id: 'Data and analytics',
      label: 'Analytics',
      title: 'Drive data decisions with Rovo',
      tabAriaLabel: 'Switch to Rovo-powered apps for analytics',
      description: 'Unlock insights and make smarter choices with Rovo-powered analytics.',
      linkText: 'Explore all apps',
      linkHref: '/collections/atlassian-rovo?categories=Data+and+analytics',
      linkAriaLabel: 'Open the full list of available Rovo-powered apps for content',
      image: RovoCollection3,
    },
    {
      id: 'IT support and service',
      label: 'IT',
      title: 'Stay ahead of risks and scale with confidence',
      tabAriaLabel: 'Switch to Rovo-powered apps for IT',
      description:
        'Proactively monitor systems, track SLA performance, and govern AI usage so your organization stays compliant, secure, and ready to grow.',
      linkText: 'Explore all apps',
      linkHref: '/collections/atlassian-rovo?categories=IT+support+and+service',
      linkAriaLabel: 'Open the full list of available Rovo-powered apps for IT',
      image: RovoCollection4,
    },
  ],
};
